export enum PageState {
  LOADING,
  LOADED,
}
